// extracted by mini-css-extract-plugin
export var blockStat = "DataItem_blockStat__Ypshx";
export var balance = "DataItem_balance__ibfkG";
export var iconWrapper = "DataItem_iconWrapper__35smU";
export var orange = "DataItem_orange__OFm0P";
export var textNumber = "DataItem_textNumber__4G2r5";
export var scalable = "DataItem_scalable__d2Q8T";
export var rotate = "DataItem_rotate__bqZDO";
export var dotty = "DataItem_dotty__fpxmK";